var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreeCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0.5C13.044 0.5 0.5 13.044 0.5 28.5C0.5 43.956 13.044 56.5 28.5 56.5C43.956 56.5 56.5 43.956 56.5 28.5C56.5 13.044 43.956 0.5 28.5 0.5ZM28.5 50.9C16.152 50.9 6.1 40.848 6.1 28.5C6.1 16.152 16.152 6.1 28.5 6.1C40.848 6.1 50.9 16.152 50.9 28.5C50.9 40.848 40.848 50.9 28.5 50.9ZM43.333 18.119C42.24 17.0183 40.4608 17.0152 39.364 18.112L22.9 34.576L17.6239 29.3203C16.532 28.2326 14.7657 28.2343 13.6759 29.3241C12.5846 30.4154 12.5846 32.1846 13.6759 33.2759L20.9201 40.5201C22.0136 41.6136 23.7864 41.6136 24.8799 40.5201L43.326 22.074C44.4173 20.9827 44.4205 19.2142 43.333 18.119Z",
    fill: "#00DFBC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreeCheckMark);
export default __webpack_public_path__ + "static/media/gree-check-mark.c903a8098564aed2f16b98edcba95f15.svg";
export { ForwardRef as ReactComponent };